import { healthBlockActionType } from '../types/healthBlockType';
import { SET_SUB_DISTRICT, SET_BLOCK, SET_ULB, SET_VILLAGE, SET_WARD, SET_SUB_DISTRICT_BY_DISTRICT, SET_BLOCK_BY_DISTRICT, SET_ULB_BY_STATE } from '@store/constant';
export interface healthBlockState {
    ulbByHealthBlockId: any,
    subDistrictByHealthBlockId: any,
    blockByHealthBlockId: any,
    villageByHealthBlockId: any,
    wardByHealthBlockId: any,
    subDistrictByDistrict: any,
    blockByDistrict: any,
    ulbByState: any
}

export const initialState: healthBlockState = {
    ulbByHealthBlockId: {},
    subDistrictByHealthBlockId: {},
    blockByHealthBlockId: {},
    villageByHealthBlockId: [],
    wardByHealthBlockId: [],
    subDistrictByDistrict: [],
    blockByDistrict: [],
    ulbByState: []
};

const healthBlockReducer = (
    state = initialState,
    action: healthBlockActionType,
): healthBlockState => {
    switch (action.type) {
        case SET_SUB_DISTRICT:
            return { ...state, subDistrictByHealthBlockId: { ...state.subDistrictByHealthBlockId, [action.payload.key]: action.payload.value } };
        case SET_BLOCK:
            return { ...state, blockByHealthBlockId: { ...state.blockByHealthBlockId, [action.payload.key]: action.payload.value } };
        case SET_ULB:
            return { ...state, ulbByHealthBlockId: { ...state.ulbByHealthBlockId, [action.payload.key]: action.payload.value } };
        case SET_VILLAGE:
            return { ...state, villageByHealthBlockId: { ...state.villageByHealthBlockId, [action.payload.key]: action.payload.value } };
        case SET_WARD:
            return { ...state, wardByHealthBlockId: { ...state.wardByHealthBlockId, [action.payload.key]: action.payload.value } };
        case SET_SUB_DISTRICT_BY_DISTRICT:
            return { ...state, subDistrictByDistrict: { ...state.subDistrictByDistrict, [action.payload.key]: action.payload.value } };
        case SET_BLOCK_BY_DISTRICT:
            return { ...state, blockByDistrict: { ...state.blockByDistrict, [action.payload.key]: action.payload.value } };
        case SET_ULB_BY_STATE:
            return { ...state, ulbByState: { ...state.ulbByState, [action.payload.key]: action.payload.value } };

        default:
            return state;
    }
};

export default healthBlockReducer;
